module.exports = __webpack_public_path__ + "static/media/socialSafetyNet.03f286dd.webp";